import styled from 'styled-components';
import { rgba } from 'polished';
import { COLOR_WHITE } from '../../assets/styles/colors';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../assets/styles/breakpoints';

export default styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 32px;
  .loading-wrap {
    display: flex;
    width: 100%;
    max-height: 100px;
  }
  .left-wrap {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    min-width: 280px;

    &--main-headline {
      padding-bottom: 24px;
    }
    &--sub-headline {
      padding-bottom: 8px;
    }
  }
  .right-wrap {
    width: 100%;
    max-width: 900px;
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    padding-bottom: 0px;
    .left-wrap {
      text-align: center;
      flex-wrap: wrap;

      &--main-headline {
        padding-bottom: 16px;
      }

      button {
        text-align: center;
      }
    }
    .right-wrap {
      width: 100%;
      max-width: 100%;
    }
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    align-items: flex-start;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding-bottom: 0px;
    .left-wrap {
      text-align: left;
      flex-wrap: wrap;
      padding-bottom: 24px;
      button {
        text-align: left;
      }
    }
  }
`;

export const BannerMainStatsSC = styled.div`
  margin-top: 16px;
  display: flex;
  border-radius: 12px;
  padding: 17px 0;
  box-shadow: 0 8px 15px 0 #2f2e41;
  background-image: linear-gradient(to bottom, #434162, #403e5b 33%, #38364e);
  .col {
    width: calc(25% - 1px);
    padding: 0px 30px 0px 16px;
    border-right: 1px solid ${rgba(COLOR_WHITE, 0.1)};
    &:last-child {
      border-right: none;
    }
  }
`;

export const BannerSliderWrapSC = styled.div`
  .slick-slide {
    margin: 0px 10px;
  }
  /* the parent */
  .slick-list {
    margin: 0 -26px 0px -15px;
  }
  .slick-track {
    margin: 15px;
  }
  .col {
    border-radius: 12px;
    box-shadow: 0 8px 15px 0 #2f2e41;
    width: calc(25% - 1px);
    padding: 17px 60px 17px 32px;
    background-image: linear-gradient(to bottom, #434162, #403e5b 33%, #38364e);
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    .slick-list {
      margin: 0 -10px 0px -15px;
    }
    .col {
      padding: 10px 40px 10px 16px;
    }
  }
`;
